// Copyright (c) 2016 Deere & Company

import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetProductDetails = () => getProductDefaultState();

const setProductDetails = (state, action) =>
    Product.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().product, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_PARTS]: resetProductDetails,
        [actions.RESET_CLAIM_PARTS_PRODUCT_DETAILS]: resetProductDetails,
        [actions.SET_CLAIM_PARTS_PRODUCT_DETAILS]: setProductDetails,
        [actions.UPDATE_CLAIM_PARTS_PART_TYPE]: resetProductDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/parts/reducers/product-details.js